<template>
  <page-container :title="dataList.name + ' - 详情页'">
    <a-card :bordered="true">
      <a-descriptions size="small" :column="4" title="加盟商信息">
        <template #extra>
          <!--          <a-button type="primary" size="small" @click="btn_record.cb"></a-button>-->
        </template>
        <a-descriptions-item label="名称">{{ dataList.name }}</a-descriptions-item>
        <a-descriptions-item label="加盟商编号">{{ dataList.code }}</a-descriptions-item>
        <a-descriptions-item label="创建日期">{{ dataList.create_time }}</a-descriptions-item>
        <a-descriptions-item label="更新时间">{{ dataList.update_time }}</a-descriptions-item>

        <a-descriptions-item label="姓名">{{ dataList.person_name }}</a-descriptions-item>
        <a-descriptions-item label="手机号">{{ dataList.person_phone }}</a-descriptions-item>
      </a-descriptions>
      <a-divider style="margin-bottom: 15px" />

      <a-tabs type="card" v-model:activeKey="activeKey">
        <a-tab-pane v-for="item in tableList" :key="item.title" :tab="item.title">
          <page-model-2 :modalType="item.modalType" :search="item.search" :title="item.title" />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </page-container>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { get_franchisee_by_id } from '@/api/jms-model';
import { useStore } from 'vuex';
import { btn_record } from '@/views/profile/basic-franchisee/basic.ts';
import PageModel2 from '@/components/page-model2/index.vue';

export default defineComponent({
  setup() {
    const route = useRoute();
    const store = useStore();
    const activeKey = ref<string>('报单');
    route.meta.title = route.params['name'];
    const current_org = store.getters['user/current_org'];
    const search = reactive({
      current: 1,
      pageSize: 20,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        org_id: current_org.id,
        is_active: true,
        franchisee_id: Number(route.params['id']),
      },
    });
    const dataList: any = reactive({
      full_name: '',
    });
    get_franchisee_by_id({
      org_id: current_org.id,
      franchisee_ids: Number(route.params['id']),
    }).then((res: any) => {
      Object.assign(dataList, res);
    });

    const tableList = reactive([
      {
        title: '报单',
        search: search,
        modalType: 'company-requestorder',
      },
      {
        title: '下单',
        search: search,
        modalType: 'company-productorder',
      },
      {
        title: '发货',
        search: search,
        modalType: 'company-sendorder',
      },
      {
        title: '撤单',
        search: search,
        modalType: 'company-backorder',
      },
      {
        title: '收款',
        search: search,
        modalType: 'company-franchiseeczrecord',
      },
      {
        title: '加盟商钱包',
        search: search,
        modalType: 'jms-franchiseewallet',
      },
    ]);

    return {
      tableList,
      route,
      activeKey,
      dataList,
      btn_record,
    };
  },
  components: {
    PageModel2,
  },
});
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 16px;
  color: @text-color;
  font-weight: 500;
  font-size: 16px;
}
</style>
